<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SD" @change="campaignSelectChange($event)"></ad-campaign-select>
        <ad-group-select ref="groupSelect" v-model="groupIds" :marketId="marketId" :campaignId="campaignId" v-if="!inGroup" adType="SD"></ad-group-select>
        <gj-select
            v-model="status"
            :options="AdProductEnum.SD.statusOption"
            placeholder="状态"
        ></gj-select>
       <!-- <gj-select
            v-if="!inCampaign && !inGroup"
            v-model="type"
            :options="AdCampaignEnum.SD.targetingTypeOption"
            placeholder="活动类型"
        ></gj-select>-->
        <gj-select-input
            v-model="keyword"
            :options="[
              {id: 'asin', text: 'ASIN'},
              {id: 'listingTitle', text: '商品标题'},
              {id: 'msku', text: 'MSKU'},
            ]"
        ></gj-select-input>
        <gj-date-picker
            v-model="date"
            type="daterange"
            :clearable="false"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSdCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :download="$permission('adsSdCampaigns:export')" download-url="/ads/adsSdProduct/export" :download-params="globalParams"
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSdCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add">
        新增广告商品
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdProductEnum.SD.status.PAUSE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdProductEnum.SD.status.ENABLE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSdCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdProductEnum.SD.status.ENABLE, AdProductEnum.SD.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSdCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :download="$permission('adsSdCampaigns:export')" download-url="/ads/adsSdProduct/export" :download-params="globalParams"
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSdCampaigns:addOrUpdate')"
          size="has-picture"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          show-summary
          sortable="custom"
          :selectable="notEqSelectable('state', AdProductEnum.SD.status.ARCHIVE)"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSdCampaigns:addOrUpdate')">
            <gj-tag
                v-if="row.state === AdProductEnum.SD.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdProductEnum.SD.status.ENABLE"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdProductEnum.SD.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:listingTitle="{row}">
          <gj-tooltip
              :content="row.listingTitle"
              :text-line="1">
            {{row.listingTitle | defaultShow}}
          </gj-tooltip>
          <el-row>
            <el-col :span="12">
              <gj-tooltip
                  :content="row.asin">
                <div class="text-ellipsis-1">
                  <span class="gj-table--label">ASIN: </span>{{row.asin}}
                </div>
              </gj-tooltip>
            </el-col>
            <el-col :span="12">
              <gj-tooltip :content="row.msku">
                <div class="text-ellipsis-1">
                  <span class="gj-table--label">MSKU: </span>{{row.msku}}
                </div>
              </gj-tooltip>
            </el-col>
          </el-row>
        </template>
        <template v-slot:belongGroup="{row}">
          <app-sd-ad-route-link
              :ad-group-manager="{marketId, campaign: row, group: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.groupName">
              {{row.groupName | defaultShow}}
            </gj-tooltip>
          </app-sd-ad-route-link>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sd-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sd-ad-route-link>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin, adDefaultSortMixin, currencySymbolMixin,
    adAdvancedFilteringMixin,
    inCampaignMixin,
    inGroupMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {AdCampaignEnum, AdProductEnum} from "../../../common/enum";
  import {queryMixin, selectionMixin} from "../../../../../../minxins";
  import AppArchiveWarningModal from "../../../common/modal/update-status/archive-warning-modal";
  import AppAddSdAdProduct from "../../common/modal/add/product/add-ad-product";
  import AppSdAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import AdGroupSelect from "modules/ad/common/components/ad-group-select.vue"
  import {isMeaningful, isMeaningless, defaultVal} from "../../../../../../utils/common";
  import {subDays} from 'date-fns';
  import {convertToDate} from "../../../../../../utils/date.util";
  import {LOG_OP_TYPE} from "../../../common/options";
  import AppAdLogModal from "../../../common/modal/log/ad-log-modal";
  import {getSdAdProductPage, updateSdAdProduct} from "../../../../../../api/ad";
  import {adStore} from "../../../common/store";

  export default {
    name: "app-sd-ad-product",
    components: {AppSdAdRouteLink, AdCampaignSelect, AdGroupSelect},
    mixins: [
      inMarketMixin, inPortfolioMixin,
      inCampaignMixin, inGroupMixin, tableNameMixin,
      selectionMixin, adBaseDataMixin, initDateMixin,
      queryMixin, currencySymbolMixin, adDefaultSortMixin,
      adAdvancedFilteringMixin
    ],
    created() {
      this.columns = [
        adFields.status,
        adFields.picture,
        adFields.listingTitle,
        {...adFields.servingStatus, options: AdProductEnum.SD.servingStatusOption},
        // this.inGroup ? null :{...adFields.groupTargetType, field: 'option:tactic', options: AdCampaignEnum.SD.targetTypeOption},
        this.inGroup ? null : adFields.belongGroup,
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        // adFields.creationDate,
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        // adFields.orderProductSales,
        adFields.acos,
        // adFields.acoas,
        // adFields.asoas,
        adFields.roas,
        adFields.op,
      ].filter(e => e !== null);
    },
    data() {
      return {
        helpName:'sdadmanager',
        campaignIds: [],
        groupIds: [],
        tableData: [],
        columns: [],
        AdProductEnum: AdProductEnum,
        AdCampaignEnum: AdCampaignEnum,
        // filter
        status: AdProductEnum.SD.status.ENABLE_PAUSE,
        type: null,
        targetType: null,
        keyword: {
          key: 'asin',
          value: null
        },
        extendSearch: null,
        date: null
      }
    },
    methods: {
      // 广告活动下拉改变
      campaignSelectChange(e) {
        this.groupIds = []
        let afferent = {
          campaignIds: e
        }
        this.$refs.groupSelect.getOptions('SD', afferent)
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      groupChange(groupId) {
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          groupIds: [],
          status: AdProductEnum.SD.status.ENABLE_PAUSE,
          type: null,
          targetType: null,
          keyword: {
            key: 'asin',
            value: null
          },
          extendSearch: null,
          date: this.initDate || [subDays(new Date(), 6), new Date()]
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) {
          return;
        }
        // 构造查询参数
        const model = {
          campaignIds: this.campaignIds,
          groupIds: this.groupIds,
          marketId: this.marketId,
          portfolioId: this.portfolioId,
          campaignId: this.campaignId,
          groupId: this.groupId,
          extendSearch: this.extendSearch,
          tactic: defaultVal(this.type, null),
          startDate: convertToDate(this.date[0]),
          endDate: convertToDate(this.date[1]),
          state: defaultVal(this.status, null),
        };
        model[this.keyword.key] = this.keyword.value;
        const params = {
          model,
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getSdAdProductPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = this.currencySymbolMixin(data.records, adStore.SD.currencySymbol);
              this.pagination = this.getPagination(data);
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
      add() {
        const modal = this.$gjCreate(AppAddSdAdProduct, {
          props: {
            marketId: this.marketId,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: `已选择 ${rows.length} 个广告商品，确认启用？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdProduct({
                marketId: this.marketId,
                adIds: rows.map(e => e.adId),
                state: AdProductEnum.SD.status.ENABLE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: `已选择 ${rows.length} 个广告商品，确认停用？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdProduct({
                marketId: this.marketId,
                adIds: rows.map(e => e.adId),
                state: AdProductEnum.SD.status.PAUSE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdProduct({
                marketId: this.marketId,
                adIds: this.selectedRows.map(e => e.adId),
                state: AdProductEnum.SD.status.ARCHIVE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate(AppAdLogModal, {
          props: {
            marketId: this.marketId,
            campaignId: this.campaignId,
            groupId: this.groupId,
            name: isMeaningful(row) ? row.asin : '',
            opId: isMeaningful(row) ? row.adId : null,
            adType: LOG_OP_TYPE.SD,
            object: LOG_OP_TYPE.SD.PRODUCT
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
